import apiClient from "../apiClient";
import { ENDPOINTS } from "../endpoints";

export const kbService = {
  listCategories: async () => (await apiClient.get(ENDPOINTS.kbCategories)).data,
  createCategory: async (payload) => (await apiClient.post(ENDPOINTS.kbCategories, payload)).data,
  deleteCategory: async (id) => (await apiClient.delete(ENDPOINTS.kbCategory(id))).data,

  searchArticles: async (params = {}) => (await apiClient.get(ENDPOINTS.kbArticles, { params })).data,
  createArticle: async (payload) => (await apiClient.post(ENDPOINTS.kbArticles, payload)).data,
  getArticle: async (id) => (await apiClient.get(ENDPOINTS.kbArticle(id))).data,
  updateArticle: async (id, payload) => (await apiClient.patch(ENDPOINTS.kbArticle(id), payload)).data,
  submitForReview: async (id) => (await apiClient.post(ENDPOINTS.kbArticleSubmitForReview(id))).data,
  publish: async (id) => (await apiClient.post(ENDPOINTS.kbArticlePublish(id))).data,
  listVersions: async (id) => (await apiClient.get(ENDPOINTS.kbArticleVersions(id))).data,
};
